import { AfterContentInit, ContentChildren, Directive, Input, QueryList } from '@angular/core';

import { ChainFocusItemDirective } from './chain-focus-item.directive';

@Directive({
    selector: '[appChainFocus]',
    standalone: true
})
export class ChainFocusDirective implements AfterContentInit {
  constructor() { }

  @ContentChildren(ChainFocusItemDirective, {descendants: true}) chainItems: QueryList<ChainFocusItemDirective>;
  @Input() initialIndex: number = 0;

  private currentIndex: number = this.initialIndex;

  ngAfterContentInit(): void {
    if (this.chainItems.length == 0) {return}

    this.chainItems.forEach((item, index) => {
      item.index = index;
    });

    setTimeout(() => {
      this.chainItems.get(this.currentIndex)?.setActive();
    }, 25);
  }

  setCurrentIndex(index: number): void {
    this.currentIndex = index;
  }

  nextItem(): void {
    if (this.currentIndex >= this.chainItems.length - 1) {return;}
    this.currentIndex++;
    this.chainItems.get(this.currentIndex)?.setActive();
  }

  prevItem(): void {
    if (this.currentIndex == 0) {return}
    this.currentIndex--;
    this.chainItems.get(this.currentIndex)?.setActive();
  }

  firstItem(): void {
    this.currentIndex = 0;
    this.chainItems.get(this.currentIndex)?.setActive();
  }

  setFullCode(codeArray: string[]): void {
    codeArray.forEach((item: string, index: number) => {
      if (index !== 0) {
        this.currentIndex++;
      }
      this.chainItems.get(this.currentIndex)?.setValue(item);
      this.chainItems.get(this.currentIndex)?.setActive();
    });
  }
}
